import React from 'react';
import { AlertTriangle, CheckCircle2, CreditCard } from 'lucide-react';
import { PaymentStatus } from '../../types';

interface PaymentStatusBadgeProps {
  status: PaymentStatus;
  className?: string;
}

export default function PaymentStatusBadge({ status, className = '' }: PaymentStatusBadgeProps) {
  const getStatusConfig = (status: PaymentStatus) => {
    switch (status) {
      case 'paid':
        return {
          icon: CheckCircle2,
          text: 'Paid',
          bgColor: 'bg-green-100',
          textColor: 'text-green-700',
          iconColor: 'text-green-500'
        };
      case 'error':
        return {
          icon: AlertTriangle,
          text: 'Error',
          bgColor: 'bg-red-100',
          textColor: 'text-red-700',
          iconColor: 'text-red-500'
        };
      default:
        return {
          icon: CreditCard,
          text: 'To be paid',
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-700',
          iconColor: 'text-orange-500'
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full ${config.bgColor} ${config.textColor} text-sm font-medium ${className}`}>
      <Icon className={`h-4 w-4 ${config.iconColor}`} />
      <span>{config.text}</span>
    </div>
  );
}